import { useState } from 'react';
import { Button, Tabs } from 'antd';
import { DownloadOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { useAppSelector } from 'app/store';
import { useLazyAbsenceDownloadQuery } from 'app/services/edpApiV1/absence';
import { uiModel } from 'entities/ui';
import { viewerModel } from 'entities/viewer';
import { RolesUser } from 'shared/enums';
import { configTabs } from 'shared/helpers/utils';
import { useTabsNavigate } from 'shared/hooks';
import { TItemsTab } from 'shared/types/types';
import { AbsenceModel } from 'entities/absence';
import { useNavigate } from 'react-router-dom';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import AbsenceArchive from './absenceArchive';
import AbsenceArchiveSubordinates from './absenceArchiveSubordinates';
import { AbsenceInProgress } from './absenceInProgress';
import AbsencePull from './absencePull';
import AbsenceSubordinates from './absenceSubordinates';
import ModalAddOneAbsence from './madalAddOneAbsence';

import style from './index.module.scss';

const itemsTab: TItemsTab = [
  {
    label: 'Общий список заявок',
    key: 'new',
    children: <AbsencePull />,
    role: [RolesUser.HRDirector, RolesUser.FirstLine, RolesUser.SecondLine, RolesUser.Employee],
  },
  {
    label: 'Подчинённые',
    key: 'other',
    children: <AbsenceSubordinates />,
    role: [RolesUser.HRDirector, RolesUser.SecondLine, RolesUser.Employee],
  },
  {
    label: 'В работе',
    key: 'my',
    children: <AbsenceInProgress />,
    role: [RolesUser.HRDirector, RolesUser.FirstLine, RolesUser.SecondLine, RolesUser.Employee],
  },
  {
    label: 'Архив',
    key: 'myArchive',
    children: <AbsenceArchive />,
    role: [RolesUser.HRDirector, RolesUser.FirstLine, RolesUser.SecondLine, RolesUser.Employee],
  },
  {
    label: 'Архив подчинённых',
    key: 'subordinatesArchive',
    children: <AbsenceArchiveSubordinates />,
    role: [RolesUser.HRDirector, RolesUser.SecondLine, RolesUser.Employee],
  },
];

const Absence = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, handler] = useTabsNavigate('absence', itemsTab[0].key);
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const [downloadTrigger] = useLazyAbsenceDownloadQuery();

  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const { absence: absenceData } = useAppSelector(AbsenceModel.Absence.selectors.getAbsence);
  const tab = useAppSelector(uiModel.Tabs.selectors.selectTabs);

  const tabPane = configTabs(role, itemsTab);
  const { data: absenceArr } = absenceData;

  const goToAbsenceImport = () => navigate('/absence/import');

  const openModal = () => setIsModalOpen(true);

  const downLoadTable = () => {
    if (tab.active === 'new') {
      downloadTrigger({ type: 'new', allAvailableOrganizations });
    }
    if (tab.active === 'other') {
      downloadTrigger({ type: 'subordinatesInWork', allAvailableOrganizations });
    }
    if (tab.active === 'my') {
      downloadTrigger({ type: 'myInWork', allAvailableOrganizations });
    }
    if (tab.active === 'myArchive') {
      downloadTrigger({ type: 'myArchive', allAvailableOrganizations });
    }
    if (tab.active === 'subordinatesArchive') {
      downloadTrigger({ type: 'subordinatesArchive', allAvailableOrganizations });
    }
  };

  return (
    <>
      <div className={style.absence__panel}>
        <h3>Неявки</h3>
        <div className={style.btnGroup}>
          {!allAvailableOrganizations && (
            <Button type="primary" icon={<UploadOutlined />} onClick={goToAbsenceImport}>
              Импортировать
            </Button>
          )}
          <Button type="primary" icon={<PlusOutlined />} onClick={openModal}>
            Добавить
          </Button>
          <Button
            type="default"
            icon={<DownloadOutlined />}
            onClick={downLoadTable}
            disabled={!absenceArr || absenceArr?.length < 1}
          >
            Скачать
          </Button>
        </div>
      </div>

      <div className={style.wrap}>
        {role && (
          <Tabs activeKey={activeTab} onChange={handler} destroyInactiveTabPane>
            {tabPane &&
              tabPane?.map(el => {
                return (
                  <Tabs.TabPane tab={el.label} key={el.key}>
                    {el.children}
                  </Tabs.TabPane>
                );
              })}
          </Tabs>
        )}
      </div>
      <ModalAddOneAbsence isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </>
  );
};

export default Absence;
